const previusAppDomain = (state = {}, action) => {
  switch (action.type) {
    case 'PREVIUS_PUBLISHED_DOMAIN':
      return {
        ...state,
        [action.appname]: action.previusDomain,
      };

    default:
      return state;
  }
};

export default previusAppDomain;
